// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderSummary_small-subtitle__jvSx9 {
  font-weight: bold;
  font-size: 20px;
}

.OrderSummary_eta__DusqL {
  font-size: 12px;
}

.OrderSummary_eta-green-color__RkF1f {
  color: green;
  margin-left: 5px;
}

.OrderSummary_eta-red-color__dhAxU {
  color: red;
  margin-left: 5px;
}

.OrderSummary_check-divider__iU2WV {
  margin: 0px -15px;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentSteps/OrderSummary/OrderSummary.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AACA;EACI,iBCKG;EDJH,eCCO;ADDX;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ","sourcesContent":["@use \"styles/typography\";\n.small-subtitle {\n    font-weight: typography.$bold;\n    font-size: typography.$header-s;\n}\n\n.eta {\n    font-size: 12px;\n}\n\n.eta-green-color {\n    color: green;\n    margin-left: 5px;\n}\n\n.eta-red-color {\n    color: red;\n    margin-left: 5px;\n}\n\n.check-divider {\n    margin: 0px -15px;\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"small-subtitle": `OrderSummary_small-subtitle__jvSx9`,
	"eta": `OrderSummary_eta__DusqL`,
	"eta-green-color": `OrderSummary_eta-green-color__RkF1f`,
	"eta-red-color": `OrderSummary_eta-red-color__dhAxU`,
	"check-divider": `OrderSummary_check-divider__iU2WV`
};
export default ___CSS_LOADER_EXPORT___;
